import React from 'react';
import Link from 'components/link';
import ThemedIcon from 'components/themed-icon';

type LogoProps = {
  ariaLabel?: string;
  href?: string;
  logoClassName?: string;
  wrapperClassName?: string;
  testId?: string;
  logoComponent?: React.ReactNode;
  /** Optional RECO legal-name caption rendered beneath the logo */
  caption?: string;
  captionClassName?: string;
};

const Logo = ({ 
  ariaLabel = 'Header logo',
  href = '/',
  logoClassName = '',
  wrapperClassName,
  testId,
  logoComponent,
  caption,
  captionClassName,
}: LogoProps) => {
  return (
    <div data-testid={testId} className={wrapperClassName}>
      <Link href={href} as={href} className={logoClassName} rel="noreferrer" ariaLabel={ariaLabel}>
        {logoComponent || <ThemedIcon />}
      </Link>
      {caption ? <p className={captionClassName}>{caption}</p> : null}
    </div>
  );
};

export default Logo; 